import { useCurrentUserContext } from 'contexts/currentUser';
import { useIsLaptop } from 'hooks/device/useIsLaptop';

export const useShowBottomBarNav = () => {
  const { currentUser } = useCurrentUserContext();
  const isTabletAndAbove = useIsLaptop();
  return !isTabletAndAbove && !!currentUser;
};
